import { redirect } from 'react-router';

import type { DraftQuotation } from '~/api/quotations/types';
import type { Params } from '~/providers/RouterProvider/router.types';

import { HttpNotFoundError } from '~/api/errors';
import { quotationQueryOptions } from '~/api/quotations';
import { queryClient } from '~/providers/QueryClientProvider/queryClient';
import { routes } from '~/providers/RouterProvider/router.routes';

export const loader = async ({ params }: { params: Params<typeof routes.createQuotation> }): Promise<DraftQuotation> => {
  const quotationId = Number(params.quotationId);

  try {
    const quotation = await queryClient.ensureQueryData(quotationQueryOptions(quotationId));

    if (quotation.status !== 'Draft') throw redirect(routes.quotations);

    return quotation;
  } catch (error) {
    if (error instanceof HttpNotFoundError) {
      throw redirect(routes.quotations);
    }

    throw error;
  }
};
